import { useEffect } from "react";
import { Map, Marker } from "@vis.gl/react-google-maps";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import { useDSGoogleMaps } from "../../hooks/DSGoogleMaps";

type AddressProps = {
  title?: string;
  latitude: number;
  longitude: number;
};

const Address = ({ latitude, longitude, title }: AddressProps) => {
  if (latitude && longitude) {
    const dsGoogleMaps = useDSGoogleMaps();

    useEffect(() => {
      if (dsGoogleMaps.map) {
        dsGoogleMaps.map.setCenter({
          lat: Number(latitude),
          lng: Number(longitude),
        });
        dsGoogleMaps.map.setZoom(16);
      }
    }, [latitude, longitude]);

    return (
      <section id="address">
        <Stack rowGap={2}>
          {title && (
            <Typography color="primary" variant="h6" fontWeight={500}>
              {title}
            </Typography>
          )}
          <Map
            id={"DS-MAP"}
            colorScheme={"LIGHT"}
            renderingType={"RASTER"}
            reuseMaps={true}
            controlled={false}
            mapTypeControl={false}
            defaultZoom={16}
            defaultCenter={{ lat: latitude, lng: longitude }}
            mapTypeId={"roadmap"}
            style={{ height: "400px" }}
          >
            <Marker position={{ lat: latitude, lng: longitude }} />
          </Map>
        </Stack>
      </section>
    );
  }

  return <></>;
};

export default Address;
